import { cn } from '@/lib/utils'
import type { LucideIcon } from 'lucide-react'

interface StatCardProps {
  label: string
  value: string | number
  icon: LucideIcon
  color?: 'green' | 'blue' | 'purple' | 'yellow' | 'red'
}

const colorMap = {
  green: {
    icon: 'text-emerald-600 dark:text-emerald-400',
    bg: 'bg-emerald-500/10',
    bar: 'bg-emerald-500',
  },
  blue: {
    icon: 'text-blue-600 dark:text-blue-400',
    bg: 'bg-blue-500/10',
    bar: 'bg-blue-500',
  },
  purple: {
    icon: 'text-purple-600 dark:text-purple-400',
    bg: 'bg-purple-500/10',
    bar: 'bg-purple-500',
  },
  yellow: {
    icon: 'text-yellow-600 dark:text-yellow-500',
    bg: 'bg-yellow-500/10',
    bar: 'bg-yellow-500',
  },
  red: {
    icon: 'text-destructive',
    bg: 'bg-destructive/10',
    bar: 'bg-destructive',
  },
}

export function StatCard({ label, value, icon: Icon, color = 'green' }: StatCardProps) {
  const c = colorMap[color]
  return (
    <div className="rounded-xl border border-border bg-card p-4 transition-colors duration-150 hover:border-primary/15">
      <div className="flex items-center justify-between mb-3">
        <span className="text-[11px] font-medium uppercase tracking-[1px] text-muted-foreground">{label}</span>
        <div className={cn('flex h-8 w-8 shrink-0 items-center justify-center rounded-lg', c.bg)}>
          <Icon className={cn('h-4 w-4', c.icon)} />
        </div>
      </div>
      <div className="text-2xl font-bold tracking-tight tabular-nums leading-none">{value}</div>
    </div>
  )
}
